import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeRoundedIcon  from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import { useV4ColorMode } from '../theme';

export default function ColorModeToggle({ sx = {} }) {
  const { mode, toggleMode } = useV4ColorMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Light Mode' : 'Dark Mode'} placement="bottom">
      <IconButton
        size="small"
        onClick={toggleMode}
        aria-label={isDark ? 'Zu Light Mode wechseln' : 'Zu Dark Mode wechseln'}
        sx={{
          color: isDark ? 'var(--v4-gold)' : 'var(--v4-purple)',
          border: '1px solid rgba(var(--v4-cyan-rgb),0.15)',
          borderRadius: '10px',
          transition: 'all 0.2s ease',
          '&:hover': { background: 'rgba(var(--v4-cyan-rgb),0.08)' },
          '& svg': { transition: 'transform 0.4s cubic-bezier(0.34,1.56,0.64,1)' },
          '&:hover svg': { transform: 'rotate(25deg)' },
          ...sx,
        }}
      >
        {isDark ? <LightModeRoundedIcon fontSize="small" /> : <DarkModeRoundedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
